(function() {
  'use strict';

  const overlay = document.querySelector('.cm-search-overlay');
  const trigger = document.querySelector('[data-search-trigger]');
  const closeBtn = document.querySelector('.cm-search-overlay__close-btn');
  const input = document.querySelector('.cm-search-overlay__input');
  const clearBtn = document.querySelector('.cm-search-overlay__clear-btn');
  const trending = document.querySelector('.cm-search-overlay__trending');
  const results = document.querySelector('.cm-search-overlay__results');
  const loading = document.querySelector('.cm-search-overlay__loading');
  const empty = document.querySelector('.cm-search-overlay__empty');
  const resultsCount = document.querySelector('.cm-search-overlay__results-count');
  const seeAllLink = document.querySelector('.cm-search-overlay__see-all');
  const resultsGrid = document.querySelector('.cm-search-overlay__grid');

  let abortController = null;
  let debounceTimer = null;
  let focusableElements = [];
  let firstFocusable = null;
  let lastFocusable = null;

  function open() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (input) input.focus();
    updateFocusableElements();
    document.dispatchEvent(new CustomEvent('search:opened'));
  }

  function close() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (input) {
      input.value = '';
      clearBtn.classList.remove('visible');
    }
    if (trending) trending.classList.add('visible');
    if (results) results.classList.remove('visible');
    if (loading) loading.classList.remove('visible');
    if (empty) empty.classList.remove('visible');
    if (trigger) trigger.focus();
    if (abortController) {
      abortController.abort();
      abortController = null;
    }
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    document.dispatchEvent(new CustomEvent('search:closed'));
  }

  function updateFocusableElements() {
    if (!overlay) return;
    focusableElements = Array.from(
      overlay.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    );
    firstFocusable = focusableElements[0];
    lastFocusable = focusableElements[focusableElements.length - 1];
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  async function addToCart(productHandle, buttonElement) {
    const originalText = buttonElement.textContent;
    
    try {
      buttonElement.textContent = 'Adding...';
      buttonElement.disabled = true;
      
      // Fetch full product data to get variants
      const productResponse = await fetch(`/products/${productHandle}.js`);
      
      if (!productResponse.ok) {
        throw new Error('Failed to fetch product data');
      }
      
      const productData = await productResponse.json();
      
      // Find first available variant
      const availableVariant = productData.variants.find(v => v.available);
      
      if (!availableVariant) {
        buttonElement.textContent = 'Sold Out';
        buttonElement.disabled = true;
        return;
      }
      
      // Add to cart with available variant
      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: availableVariant.id,
          quantity: 1
        })
      });
      
      if (!cartResponse.ok) {
        throw new Error('Failed to add to cart');
      }
      
      window.location.href = '/cart';
      
    } catch (error) {
      buttonElement.textContent = 'Error - Try Again';
      buttonElement.disabled = false;
      
      setTimeout(() => {
        buttonElement.textContent = originalText;
      }, 3000);
    }
  }

  async function fetchResults(query) {
    if (!query || query.length < 2) {
      if (trending) trending.classList.add('visible');
      if (results) results.classList.remove('visible');
      if (empty) empty.classList.remove('visible');
      return;
    }

    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();

    if (trending) trending.classList.remove('visible');
    if (results) results.classList.remove('visible');
    if (empty) empty.classList.remove('visible');
    if (loading) loading.classList.add('visible');

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`,
        { signal: abortController.signal }
      );
      
      if (!response.ok) throw new Error('Search failed');
      
      const data = await response.json();
      displayResults(data, query);
    } catch (error) {
      if (error.name !== 'AbortError') {
        if (loading) loading.classList.remove('visible');
        if (empty) {
          empty.classList.add('visible');
          empty.querySelector('.cm-search-overlay__empty-title').textContent = `No results for "${query}"`;
        }
      }
    } finally {
      abortController = null;
    }
  }

  function displayResults(data, query) {
    if (loading) loading.classList.remove('visible');

    const products = data.resources?.results?.products || [];
    const collections = data.resources?.results?.collections || [];
    const totalResults = products.length + collections.length;

    if (totalResults === 0) {
      if (empty) {
        empty.classList.add('visible');
        empty.querySelector('.cm-search-overlay__empty-title').textContent = `No results for "${query}"`;
      }
      return;
    }

    if (resultsCount) {
      resultsCount.textContent = `${totalResults} results for "${query}"`;
    }

    if (seeAllLink) {
      seeAllLink.href = `/search?q=${encodeURIComponent(query)}`;
    }

    if (resultsGrid) {
      resultsGrid.innerHTML = products.map(product => {
        // TEMPORARY: Log full product object to check available fields for variant detection
        if (products.indexOf(product) === 0) {
          console.log('SUGGEST.JSON PRODUCT KEYS:', Object.keys(product));
          console.log('FULL PRODUCT OBJECT:', product);
        }
        
        const price = product.price;
        const comparePrice = product.compare_at_price;
        const isOnSale = comparePrice && parseFloat(comparePrice) > parseFloat(price);
        const hasMultipleVariants = product.variants && product.variants.length > 1;
        const isSoldOut = !product.available;
        
        // Check for best-seller tags
        const hasBestSellerBadge = product.tags && (product.tags.includes('best seller') || product.tags.includes('best-seller'));
        
        // Generate variant swatches (visual only) - ONLY for Color/Colour options
        let swatchesHtml = '';
        if (hasMultipleVariants && product.options) {
          const colorOption = product.options.find(opt => 
            opt.name && (opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour')
          );
          
          if (colorOption && colorOption.values) {
            const colorValues = colorOption.values.slice(0, 4);
            
            // Simple color name mapping for common wig colors
            const colorMap = {
              'black': '#000000',
              'natural black': '#1a1a1a',
              'brown': '#8B4513',
              'blonde': '#F5DEB3',
              'red': '#8B0000',
              'gray': '#808080'
            };
            
            swatchesHtml = colorValues.map(color => {
              const normalizedColor = color.toLowerCase().trim();
              const bgColor = colorMap[normalizedColor] || normalizedColor;
              return `<span class="cm-search-overlay__swatch" style="background-color: ${bgColor}" title="${color}"></span>`;
            }).join('');
          }
        }
        
        return `
          <div class="cm-search-overlay__product-card" data-product-handle="${product.handle}">
            <a href="${product.url}" class="cm-search-overlay__product-card-link" tabindex="0">
              ${hasBestSellerBadge ? `
                <span class="cm-search-overlay__badge cm-search-overlay__badge--bestseller">Best Seller</span>
              ` : ''}
              ${product.featured_image ? `
                <img 
                  src="${product.featured_image.url}" 
                  alt="${product.title}" 
                  class="cm-search-overlay__product-image"
                  width="400"
                  height="533"
                  loading="lazy"
                >
              ` : ''}
              ${swatchesHtml ? `
                <div class="cm-search-overlay__swatches">${swatchesHtml}</div>
              ` : ''}
              <div class="cm-search-overlay__product-title">${product.title}</div>
              <div class="cm-search-overlay__product-price ${isOnSale ? 'cm-search-overlay__product-price--sale' : ''}">
                ${price}
                ${isOnSale ? `<span class="cm-search-overlay__compare-price">${comparePrice}</span>` : ''}
              </div>
            </a>
            ${!isSoldOut ? `
              <button class="u-cta u-cta--fill cm-search-overlay__product-card-btn" data-add-to-cart>Add to Cart - ${price}</button>
            ` : `
              <button class="u-cta u-cta--fill cm-search-overlay__product-card-btn" disabled>Sold Out</button>
            `}
          </div>
        `;
      }).join('');
      
      // Re-attach add-to-cart listeners after updating DOM
      const newAddButtons = resultsGrid.querySelectorAll('[data-add-to-cart]');
      newAddButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const productHandle = btn.closest('[data-product-handle]').dataset.productHandle;
          addToCart(productHandle, btn);
        });
      });
    }

    if (results) results.classList.add('visible');
    updateFocusableElements();
  }

  function handleInput(e) {
    const value = e.target.value.trim();
    
    if (clearBtn) {
      clearBtn.classList.toggle('visible', value.length > 0);
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchResults(value);
    }, 300);
  }

  function handleClearBtn() {
    if (input) {
      input.value = '';
      input.focus();
    }
    if (clearBtn) clearBtn.classList.remove('visible');
    if (trending) trending.classList.add('visible');
    if (results) results.classList.remove('visible');
    if (empty) empty.classList.remove('visible');
  }

  function handleKeyDown(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      const cards = resultsGrid?.querySelectorAll('.cm-search-overlay__product-card') || [];
      if (cards.length === 0) return;

      e.preventDefault();
      const currentIndex = Array.from(cards).indexOf(document.activeElement);
      let nextIndex;

      if (e.key === 'ArrowDown') {
        nextIndex = currentIndex < cards.length - 1 ? currentIndex + 1 : 0;
      } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : cards.length - 1;
      }

      cards[nextIndex].focus();
    }

    if (e.key === 'Enter') {
      const activeElement = document.activeElement;
      if (activeElement.classList.contains('cm-search-overlay__product-card')) {
        activeElement.click();
      }
    }
  }

  function init() {
    if (!overlay || !trigger) return;

    trigger.addEventListener('click', open);
    
    if (closeBtn) closeBtn.addEventListener('click', close);
    
    if (input) {
      input.addEventListener('input', handleInput);
      input.addEventListener('keydown', handleKeyDown);
    }
    
    if (clearBtn) clearBtn.addEventListener('click', handleClearBtn);

    // Trending products add-to-cart handlers
    const trendingAddButtons = document.querySelectorAll('[data-add-to-cart]');
    trendingAddButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const productHandle = btn.closest('[data-product-handle]').dataset.productHandle;
        addToCart(productHandle, btn);
      });
    });

    // Trending products dot pagination
    const trendingScroll = document.querySelector('.cm-search-overlay__trending-products-scroll');
    const trendingTrack = document.querySelector('.cm-search-overlay__trending-products-track');
    const trendingDots = document.querySelector('.cm-search-overlay__trending-products-dots');
    
    if (trendingScroll && trendingTrack && trendingDots) {
      const cards = trendingTrack.querySelectorAll('.cm-search-overlay__trending-card');
      
      // Generate dots
      cards.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'cm-search-overlay__trending-dot';
        dot.setAttribute('aria-label', `View trending product ${index + 1}`);
        if (index === 0) dot.classList.add('is-active');
        dot.addEventListener('click', () => {
          const cardWidth = cards[0].offsetWidth + parseFloat(getComputedStyle(trendingTrack).gap);
          trendingScroll.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
        });
        trendingDots.appendChild(dot);
      });
      
      // Update active dot on scroll
      trendingScroll.addEventListener('scroll', () => {
        const cardWidth = cards[0].offsetWidth + parseFloat(getComputedStyle(trendingTrack).gap);
        const scrollLeft = trendingScroll.scrollLeft;
        const activeIndex = Math.round(scrollLeft / cardWidth);
        
        const dots = trendingDots.querySelectorAll('.cm-search-overlay__trending-dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeIndex);
        });
      });
    }

    overlay.addEventListener('keydown', trapFocus);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
